// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yUpc","importantInfo":"styles_importantInfo__1fVAK"};